<template id="challenge-card">
    <swiper-slide>
        <a v-bind:href="signUpUrl">
            <div class="challenge-card-container" :class="{big: isBigContainer}">
                <div class="header">
                    <div class="img-container">
                        <img loading="lazy" :src="src" alt="HealthyWage challenge img">
                    </div>
                    <div class="titles-container">
                        <h2 class="title">{{title}}</h2>
                        <h5 class="subtitle" v-if="subtitle">{{subtitle}}</h5>
                    </div>
                </div>

                <ChallengeCardPrize v-bind:prizeValue="prizeValue" v-bind:potValue="potValue" v-bind:type="type" v-bind:potTitle="potTitle" />
                <ChallengeCardContent v-bind:betValue="betValue" v-bind:teamSize="teamSize" v-bind:dateRange="dateRange" />
                <ChallengeCardSignUp v-bind:signUpUrl="signUpUrl" />
            </div>
        </a>
    </swiper-slide>
</template>

<script>
import ChallengeCardPrize from './ChallengeCardPrize';
import ChallengeCardContent from './ChallengeCardContent';
import ChallengeCardSignUp from './ChallengeCardSignUp';
import { swiperSlide } from 'vue-awesome-swiper'

export default {
  template: '#challenge-card',
  props: ['src', 'title', 'type', 'potValue', 'prizeValue', 'betValue', 'teamSize', 'dateRange', 'signUpUrl', 'isBigContainer', 'subtitle', 'potTitle'],
  components: { ChallengeCardPrize, ChallengeCardContent, ChallengeCardSignUp, 'swiper-slide': swiperSlide }
}
</script>
